import { FormField } from '@bm-js/atlascloud-shared'

const defaultEmailField: FormField = {
  type: 'email',
  name: 'Mailadress',
  required: true,
  width: 'half',
}
const defaultNameField: FormField = {
  type: 'text',
  name: 'Namn',
  required: true,
  width: 'half',
}
const defaultMessageField: FormField = {
  type: 'textarea',
  name: 'Meddelande',
  required: true,
  width: 'full',
}

export const formDefaultFields = [
  defaultNameField,
  defaultEmailField,
  defaultMessageField,
]
